import React, { useState } from 'react';
import { useModal } from '@/contexts/ModalProvider';
import { CommonModal } from '@/components/common/CommonModal';
import { Button } from '@/components/ui/button';
import { StyledButton } from '@/components/common/StyledButton';
import { Loader2 } from 'lucide-react';

const ConfirmDialog: React.FC = () => {
  const { modals, closeModal } = useModal();
  const modal = modals.confirm;
  const [isLoading, setIsLoading] = useState(false);

  if (!modal) return null;

  const handleConfirm = async () => {
    if (modal.onConfirm) {
      setIsLoading(true);
      try {
        await modal.onConfirm();
        closeModal('confirm');
      } catch (error) {
        console.error('Confirm action failed:', error);
      } finally {
        setIsLoading(false);
      }
    } else {
      closeModal('confirm');
    }
  };

  const handleCancel = () => {
    if (modal.onCancel) {
      modal.onCancel();
    }
    closeModal('confirm');
  };

  const footer = (
    <div className="flex gap-2 justify-end">
      <Button
        variant="outline"
        onClick={handleCancel}
        disabled={isLoading}
      >
        {modal.cancelText || 'Cancel'}
      </Button>
      <StyledButton
        onClick={handleConfirm}
        disabled={isLoading}
      >
        {isLoading ? (
          <>
            <Loader2 className="mr-2 size-4 animate-spin" />
            Processing...
          </>
        ) : (
          modal.confirmText || 'Confirm'
        )}
      </StyledButton>
    </div>
  );

  return (
    <CommonModal
      open={modal.visible}
      onOpenChange={(open) => !open && handleCancel()}
      title={modal.title}
      description={modal.description}
      footer={footer}
    >
      <div className="py-4">
        {/* Additional content can go here if needed */}
      </div>
    </CommonModal>
  );
};

export default ConfirmDialog;
